import React from "react";

function SectionHeader({ icon, title }) {
  return (
    <header className="flex flex-wrap gap-2 items-center w-full text-xl font-semibold leading-snug text-gray-700 max-md:max-w-full">
      <span className="flex shrink-0 self-stretch my-auto w-6 h-6" />
      <h2 className="flex-1 shrink self-stretch my-auto basis-0 max-md:max-w-full">
        {title}
      </h2>
    </header>
  );
}

export default SectionHeader;
